// /utils/validation.js
import config from "./conf.js";

const cleanPlaceholder = (value) => {
  if (value === undefined || value === null) return undefined;
  const normalized = `${value}`.toLowerCase();
  if (['default_s3', 'default_origin', 'defaultuuid', 'default_uuid'].includes(normalized)) {
    return undefined;
  }
  return value;
};

const getStoredData = () => {
  const storedSession = sessionStorage.getItem('userData');
  const storedLocal = localStorage.getItem('userData');
  const storedDataRaw = storedSession
    ? JSON.parse(storedSession)
    : storedLocal
    ? JSON.parse(storedLocal)
    : {};
  return {
    s3: cleanPlaceholder(storedDataRaw.s3),
    origin: cleanPlaceholder(storedDataRaw.origin),
    UUID: cleanPlaceholder(storedDataRaw.UUID),
    examType: storedDataRaw.examType,
    attemptNumber: storedDataRaw.attemptNumber,
  };
};

// /<s3>/<origin>/<UUID>/<examType>/<attemptNumber>
const getPathData = () => {
  const [pathS3, pathOrigin, pathUUID, pathExamType, pathAttemptNumber] = window.location.pathname
    .split('/')
    .filter(Boolean);
  return {
    s3: cleanPlaceholder(pathS3),
    origin: cleanPlaceholder(pathOrigin),
    UUID: cleanPlaceholder(pathUUID),
    examType: pathExamType,
    attemptNumber: pathAttemptNumber,
  };
};

const getQueryData = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return {
    s3: cleanPlaceholder(searchParams.get('s3')),
    origin: cleanPlaceholder(searchParams.get('origin')),
    UUID: cleanPlaceholder(searchParams.get('UUID')),
    examType: searchParams.get('examType'),
    attemptNumber: searchParams.get('attemptNumber'),
  };
};

const mergeUserData = ({ queryData, pathData, storedData }) => {
  // Base precedence: query > path > storage
  let s3 = queryData.s3 || pathData.s3 || storedData.s3;
  let origin = queryData.origin || pathData.origin || storedData.origin;
  let UUID = queryData.UUID || pathData.UUID || storedData.UUID;
  let examType = queryData.examType || pathData.examType || storedData.examType || 'autonocog';
  let attemptNumber = queryData.attemptNumber || pathData.attemptNumber || storedData.attemptNumber || null;

  // If query tries to force open_demo but path has real data, trust the path.
  const queryIsOpenDemo = queryData.origin === 'open_demo';
  const pathHasData = Boolean(pathData.origin && pathData.UUID);
  if (queryIsOpenDemo && pathHasData) {
    origin = pathData.origin;
    s3 = pathData.s3 || s3;
    UUID = pathData.UUID || UUID;
    attemptNumber = pathData.attemptNumber || attemptNumber;
  }

  return { data: { s3, origin, UUID, examType, attemptNumber }, pathHasData };
};

const applyDemoDefaults = ({ data, pathHasData }) => {
  // Only apply open_demo defaults if we still landed on open_demo AND no path data exists.
  if (data.origin === 'open_demo' && !pathHasData) {
    const attempt = data.attemptNumber || (Math.floor(Math.random() * 10000000) + 1).toString();
    return {
      s3: 'autonocogs3',
      origin: 'open_demo',
      UUID: '65ac6c4795f22ab627234c91',
      examType: 'autonocog',
      attemptNumber: attempt,
    };
  }
  return data;
};

// Function to parse custom URL parameters
export const parseCustomUrlParams = () => {
  const storedData = getStoredData();
  console.log(storedData)
  const pathData = getPathData();
  console.log(pathData)
  const queryData = getQueryData();
  console.log(queryData)
  
  const merged = mergeUserData({ queryData, pathData, storedData });
  console.log(merged)
  const userData = applyDemoDefaults(merged);
  console.log(userData)

  if (!userData.s3 || !userData.origin || !userData.UUID) {
    console.error('Missing required userData from URL or storage; deep link is incomplete.');
    throw new Error('Missing required userData (s3, origin, UUID)');
  }

  console.log('Extracted data from URL/session: ', userData);

  // Persist for reloads/tabs without forcing URL rewrites
  sessionStorage.setItem('userData', JSON.stringify(userData));
  localStorage.setItem('userData', JSON.stringify(userData));

  return userData;
};

// Function to validate AutonoCog link
export const validateAutonocogBlank = async (patientId, databaseName = '', testNumber) => {
    const url = `${config.COGNET_DB_API_URL}/public/validate_autonocog_link/${patientId}/${databaseName}/${testNumber}`;
    console.log("Requesting validation from URL: " + url);
  
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data.link_status === true;
      } 

    catch (error) { // Return false in case of any errors
      console.error('Error fetching data: ', error);
      return null;
      }
}
